/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent, Typography, Box,Container,CircularProgress} from '@mui/material';
import Header from '../../components/layout/Header';
import backgroundImage from '../../assets/images/bg1.webp';
import DynamicForm from '../../components/DynamicForm';

export default function LandingPage() {
  const url = process.env.REACT_APP_BACKEND_URL;
 const [formData, setFormData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const { form_name } = useParams();

const getApiURL = () => {
  const { search } = window.location;
  const params = new URLSearchParams(search);

  const uuid = params.get("uuid");
  const isTestMode = params.get("isTest");
  let apiUrl = `${url}/${form_name}`;
  
  if (uuid) apiUrl += `/charge/${encodeURIComponent(uuid)}`;

  const queryString = isTestMode ? `?isTestMode=${encodeURIComponent(isTestMode)}` : "";
  return apiUrl + queryString;
};

    useEffect(() => {
        const fetchFormFields = async () => {
            try {
                const response = await fetch(getApiURL());
                if (!response.ok) 
                  { 
                    const data = await response.json()
                    throw new Error(data.message);}
                    setLoading(false);
                const data = await response.json();
                setFormData(data || { fields: [] }); // Ensure `fields` is always an array
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchFormFields();
    }, [form_name]);

    const handleFormSubmit = (formValues) => {
      setLoading(true); // Show loader
        const nameToIdMap = formData.formFields.reduce((acc, field) => {
          acc[field.name] = field.id;
          return acc;
      }, {});
      const formDataWithIds = Object.keys(formValues).reduce((acc, key) => {
          const fieldId = nameToIdMap[key];
          if (fieldId) {
              acc[Number(fieldId)] = formValues[key];
          }
          return acc;
          
      }, {});
        // Example API call to submit form data
        fetch(getApiURL(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formDataWithIds)
        })
        .then(async response => {
          
          if (!response.ok) {
            setLoading(false); // Show loader
            // Attempt to parse error message from response
            const errorData = await response.json();
            throw new Error(errorData.message || `HTTP Error: ${response.status}`);
        }
         return response.json()
        
        })
        .then(data => {
          setLoading(false); // Show loader
         
            window.location.href = data.paymentURL; // Redirect if needed
        })
        .catch(error => 
        {setError(error.message) });
    };
    // if (loading) return <h1>Loading...</h1>;
    // if (error) return <h1>Error: {error}</h1>;
  return (
    
    <Box sx={{     backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat', width: '100vw',
          height: '100vh',}}>
  <Container sx={{p:0}}>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        sx={{ width: '100%' }}
      >
        <Card 
          sx={{
            width: { xs: "100%", sm: "80%", md: "60%", lg: "60%" }, // Full width on mobile, smaller on larger screens
            //height: '100vh', // Fill entire height
            height: { xs: "100vh", md: "80vh" }, // 100vh for larger screens
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between', // Push header to top, button to bottom
          }}>

        <CardContent sx={{p:0,  position: 'sticky',
              top: 0,
              zIndex: 2,
              backgroundColor: "white",
              pb: 1,}}>
         {formData && <Header formDetails={formData} />}
          </CardContent>
        
          {/* Tag Section */}
          <CardContent sx={{
              position: 'sticky',
              top: 0,
              zIndex: 1, // Ensure it stays on top of scrolling content
              backgroundColor: 'white',
              pb:1 // Prevent overlap
            }} >
            <Typography variant='h6' color="text.secondary" align="center">
            {formData?.formTag || "Loading..."}
            
            </Typography>
            <Typography variant='h10' align="left">
              Fields with (*) are Mandatory
            </Typography>
          </CardContent>

          {/* Form Section */}
          <CardContent
            sx={{
              // overflow: 'auto',
              overflowY: "auto",
              flexGrow: 1, // This makes the form section take available space and scroll
              maxHeight: { xs: '60vh', sm: '80%', md: '400px' },
              paddingTop: '0px'  // Set max height to make the form scrollable
            }}
          >
        {/* <DynamicForm formData={formData} onSubmit={handleFormSubmit} /> */}
        {formData ? <DynamicForm formData={formData} onSubmit={handleFormSubmit} /> : <Typography>Loading Form...</Typography>}
          </CardContent>

          {/* Submit Button */}
          <Box sx={{ position: 'sticky',zIndex: 1, bottom: 0, p: 2, backgroundColor: 'white' }}>
            {/* <Button type="submit" variant="contained" color="primary" fullWidth>
              Submit
            </Button> */}
          </Box>
        </Card>
      </Box>
    </Container>

 {/* Overlay Loading Spinner */}
 {loading && (
                <Box sx={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999
                }}>
                    <CircularProgress size={80} sx={{ color: "white" }} />
                </Box>
            )}

            {/* Error Handling */}
            {error && (
                <Box sx={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    backgroundColor: "white",
                    padding: 3,
                    borderRadius: 2,
                    boxShadow: 3,
                    zIndex: 9999
                }}>
                    <Typography color="error">Error: {error}</Typography>
                </Box>
            )}
  

    </Box>
  
  );
}
